/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
$(document).ready(function(){
    function renderSaleBadgeText($saleBadge, cleanSaleOff) {
        var finalSaleMatch = cleanSaleOff.match(/^\s*final\s+sale\s*-?\s*(.*)$/i);

        $saleBadge.removeClass('sale-box-featured--final').empty();

        if (finalSaleMatch) {
            $saleBadge.addClass('sale-box-featured--final');
            $('<span/>', {
                class: 'sale-box-featured__line',
                text: 'FINAL SALE'
            }).appendTo($saleBadge);
            if (finalSaleMatch[1]) {
                $('<span/>', {
                    class: 'sale-box-featured__line',
                    text: finalSaleMatch[1].trim()
                }).appendTo($saleBadge);
            }
            return;
        }

        $saleBadge.text(cleanSaleOff);
    }

    function updateSaleBadge($productItem, saleOff) {
        saleOff = saleOff || '';
        var cleanSaleOff = saleOff.trim();
        var $saleBadge = $productItem.find('.sale-box-featured').not('.sale-box-featured-right');

        if ($saleBadge.length) {
            if (cleanSaleOff) {
                $saleBadge.each(function() {
                    renderSaleBadgeText($(this), cleanSaleOff);
                }).show();
            } else {
                $saleBadge.removeClass('sale-box-featured--final').empty().hide();
            }
        }

        $productItem.attr('data-sale', cleanSaleOff ? 'true' : 'false');
        $productItem.attr('data-discount', cleanSaleOff.replace(/[^\d]/g, ''));
    }

    // Event delegation for clicking on swatch links
     $(document).on('click', '.template-collection .radio__fieldset--swatches .swatch__link', function(e) {
        e.preventDefault();
      
        var color = $(this).attr('data-swatch');
        var $swatchContainer = $(this).closest('.radio__fieldset--swatches');
        $swatchContainer.find('.swatch__button').removeClass('active-swatch');
        $(this).parent().addClass('active-swatch');
        $swatchContainer.closest('.product-item__info').find('.selected-color').text(color);
      $swatchContainer.closest('.product-item__info').parent().prev().find('.wishlist-engine').attr('data-variant_id',$(this).parent().attr('data-swatch-variant'))
    var $productContainer =  $swatchContainer.closest('.product-item__info');
      
      var selectedColor = $productContainer.find('.selected-color').text();
        var option2 = $productContainer.find('.selected-option').eq(0).text();
        var $selectElement = $productContainer.find('.hidden-variant-data');
        
        $selectElement.find('option').each(function() {
        if ($(this).attr('data-option1') === selectedColor && $(this).attr('data-option2') === option2) {      
          var price = $(this).attr('data-price');
          var comparePrice = $(this).attr('data-compare-price');
       //   $productContainer.find('.new-price').html(price);

          
        //   $productContainer.find('.old-price').html(comparePrice);
         // $productContainer.find('.new-price').html(price);

          $productContainer.find('.new-price').html(price);

// Check if the compare at price is the same as the regular price
if (price === comparePrice || !comparePrice) {
    // Hide the old price if it's equal to the regular price or not present
    $productContainer.find('.old-price').hide();
} else {
    // Otherwise, show the old price
    $productContainer.find('.old-price').html(comparePrice).show();
}

          var customBadge = $(this).attr('custom-badge');
var $productItem = $productContainer.closest('.grid-item');
var $prodBadge = $productItem.find('.prod-badge');

// Check if the customBadge text is empty or null
if (!customBadge || customBadge.trim() === '') {
    // Hide the .prod-badge container
    $prodBadge.closest('div').hide();
} else {
    // Set the text if it's not empty
    $prodBadge.closest('div').show();
    $prodBadge.text(customBadge);
}

          
           var saleOff = $(this).attr('sale-off');
        
            updateSaleBadge($productItem, saleOff);
          
          var imageurl = '';
         if($('.active-image-filter').attr('data-filter') == 'dogs'){
             imageurl = $(this).attr('data-dogimage');
            $productContainer.parent().parent().find('.product-item__image .dog-image img').attr('src',imageurl).attr('srcset',imageurl)
         }
          else if($('.active-image-filter').attr('data-filter') == 'studio'){
            imageurl = $(this).attr('data-studioimage');
            $productContainer.parent().parent().find('.product-item__image .studio-image img').attr('src',imageurl).attr('srcset',imageurl)
          }
          $productContainer.parent().parent().find('.product-link').attr('href',$(this).attr('data-url'));
          if($(this).attr('data-available') == 'true'){
            $productContainer.find('.btn-quick-add').text('Add To Cart');
          }
          else{
            $productContainer.find('.btn-quick-add').text('Sold Out');
          }
        }
        });
       updateSizeOptions($productContainer, color);
    });

function updateSizeOptions($productContainer, selectedColor) {
    var $sizeContainer = $productContainer.find('.other-option-swatches');
    var isBarneyChillPad = $productContainer.closest('.barney-chill-pad').length > 0; // Ensures we're inside `.barney-chill-pad`
    var firstAvailableSize = null;

    $sizeContainer.find('.other-option-value').each(function () {
        var size = $(this).data('value');
        var isSizeAvailable = false;

        // Loop through variants to check availability for selected color and each size
        $productContainer.find('.hidden-variant-data option').each(function () {
            if ($(this).attr('data-option1') === selectedColor && $(this).attr('data-option2') === size) {
                isSizeAvailable = $(this).attr('data-available') === 'true';
            }
        });

        // Special case for `.barney-chill-pad`
        if (isBarneyChillPad) {
            if (size === 'Curl/S') {
                isSizeAvailable = false; // Always hide Curl/S
            }

            // Hide unavailable sizes **only** for `.barney-chill-pad`
            $(this).toggle(isSizeAvailable);
        }

        // For all grids, update availability styling
        $(this).toggleClass('unavailable', !isSizeAvailable);
        $(this).attr('data-available', isSizeAvailable);

        // Store the first available size for `.barney-chill-pad`
        if (isBarneyChillPad && isSizeAvailable && !firstAvailableSize) {
            firstAvailableSize = size;
        }
    });

    // Auto-select the first available size **only** for `.barney-chill-pad`
    if (isBarneyChillPad && firstAvailableSize) {
        $sizeContainer.find(`.other-option-value[data-value="${firstAvailableSize}"]`).trigger('click');
    }
}




    // Event delegation for clicking on other option values
    $(document).on('click', '.other-option-swatches .other-option-value', function() {
        var $otherOptionContainer = $(this).closest('.other-option-swatches');
        $otherOptionContainer.find('.other-option-value').removeClass('selected-option');
        $(this).addClass('selected-option');
        var $productContainer = $(this).closest('.product-item__info');
       $productContainer.find('.price-from').hide();
        var selectedColor = $productContainer.find('.selected-color').text();
        var option2 = $productContainer.find('.selected-option').eq(0).text();
        var $selectElement = $productContainer.find('.hidden-variant-data');

      
        $selectElement.find('option').each(function() {
        if ($(this).attr('data-option1') === selectedColor && $(this).attr('data-option2') === option2) {      
            var price = $(this).attr('data-price');
          var comparePrice = $(this).attr('data-compare-price');
       //   $productContainer.find('.new-price').html(price);
        //   $productContainer.find('.old-price').html(comparePrice);
        //  $productContainer.find('.new-price').html(price);

          $productContainer.find('.new-price').html(price);

// Check if the compare at price is the same as the regular price
if (price === comparePrice || !comparePrice) {
    // Hide the old price if it's equal to the regular price or not present
    $productContainer.find('.old-price').hide();
} else {
    // Otherwise, show the old price
    $productContainer.find('.old-price').html(comparePrice).show();
}

         var customBadge = $(this).attr('custom-badge');
var $productItem = $productContainer.closest('.grid-item');
var $prodBadge = $productItem.find('.prod-badge');

// Check if the customBadge text is empty or null
if (!customBadge || customBadge.trim() === '') {
    // Hide the .prod-badge container
    $prodBadge.closest('div').hide();
} else {
    // Set the text if it's not empty
    $prodBadge.text(customBadge);
}

          
           var saleOff = $(this).attr('sale-off');
         
            updateSaleBadge($productItem, saleOff);
          $productContainer.find('.wishlist-engine').attr('data-variant_id',$(this).attr('value'))
          var imageurl = '';
         if($('.active-image-filter').attr('data-filter') == 'dogs'){
             imageurl = $(this).attr('data-dogimage');
           $productContainer.parent().parent().find('.product-item__image .dog-image img').attr('src',imageurl).attr('srcset',imageurl)
         }
          else if($('.active-image-filter').attr('data-filter') == 'studio'){
            imageurl = $(this).attr('data-studioimage');
            $productContainer.parent().parent().find('.product-item__image .studio-image img').attr('src',imageurl).attr('srcset',imageurl)
          }
          $productContainer.parent().parent().find('.product-link').attr('href',$(this).attr('data-url'))
          if($(this).attr('data-available') == 'true'){
            $productContainer.find('.btn-quick-add').text('Add To Cart');
          }
          else{
            
            $productContainer.find('.btn-quick-add').text('Sold Out');
          }
          $productContainer.find('.selected-size-text').text(' - '+option2)
        }
        else if(selectedColor.replace(/\s+/g, '').length == 0){
          if($(this).attr('data-option1') == option2 ){
            var price = $(this).attr('data-price');
           
          $productContainer.find('.new-price').html(price);
          $productContainer.find('.wishlist-engine').attr('data-variant_id',$(this).attr('value'))
                      var imageurl = '';
          if($('.active-image-filter').attr('data-filter') == 'dogs'){
            imageurl = $(this).attr('data-dogimage');
            $productContainer.parent().parent().find('.product-item__image .dog-image img').attr('src',imageurl).attr('srcset',imageurl)
          }
          else if($('.active-image-filter').attr('data-filter') == 'studio'){
            imageurl = $(this).attr('data-studioimage');
            $productContainer.parent().parent().find('.product-item__image .studio-image img').attr('src',imageurl).attr('srcset',imageurl)
          }
            $productContainer.parent().parent().find('.product-link').attr('href',$(this).attr('data-url'))
            if($(this).attr('data-available') == 'true'){
            $productContainer.find('.btn-quick-add').text('Add To Cart');
          }
          else{
            $productContainer.find('.btn-quick-add').text('Sold Out');
          }
          }
        }
        });
      if($productContainer.find('[data-preselected-size]').length > 0){
        $productContainer.find('.selected-variant-title').text(' - '+option2);
      }
    });

// Event delegation for the quick add button
$(document).on('click', '.btn-quick-add', function() {
    var $productContainer = $(this).closest('.product-item__info');
    var selectedColor = $productContainer.find('.selected-color').text();
    var option2 = $productContainer.find('.selected-option').eq(0).text();
    var singlevariant = $(this).attr('data-single-variant');
    var $selectElement = $(this).next('select');
    $selectElement.find('option').each(function() {
        if ($(this).attr('data-option1') === selectedColor && $(this).attr('data-option2') === option2) {
            addToCart($(this).val(), 1, singlevariant);
        } else if (singlevariant === 'true') {
            addToCart($(this).val(), 1, singlevariant);
        }
        else if(selectedColor == '' && $(this).attr('data-option1') === option2){
          addToCart($(this).val(), 1, singlevariant);
        }
    });
});

function addToCart(variantId, quantity, singlevariant) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: quantity,
            id: variantId
        },
        dataType: 'json',
        success: function(response) {

            
                 
          
            if ($(window).width() > 767) {
              setTimeout(function(){
               document.querySelector('[data-cart-toggle]').click();
              },1000)

            } else {
                $('.cart-item-image').attr('src', response.image);
                $('.cart-item-title').text(response.title);
                $('.mobile-cart-popup').show();
                setTimeout(function() {
                    $('.mobile-cart-popup').hide();
                }, 3000);

               $.getJSON('/cart.js', function(data) {
                    $('.header__cart__status').text(data.item_count);
                  const itemCount = data.item_count || 0; // Set to 0 if cart is empty
                  const cartCountElement = document.querySelector('cart-count[data-cart-count]');
                if (cartCountElement) {
                    cartCountElement.setAttribute('data-cart-count', itemCount);
                    cartCountElement.textContent = itemCount;
                }
                });

            }
        },
        error: function(error) {
            console.log('Error adding product to cart:', error);
        }
    });
}

// Event delegation for the image filter items
$(document).ready(function() {
    // Function to apply the image filter based on the filter type
    function applyImageFilter(filterValue) {
        // Remove active class from all items
        $('.template-collection .image-filter-item').removeClass('active-image-filter');
        
        // Add active class to the selected filter item
        $('.template-collection .image-filter-item[data-filter="' + filterValue + '"]').addClass('active-image-filter');

        // Apply the filter logic
        if (filterValue === 'dogs') {
            $('.dog-image').show().each(function() {
                $(this).parent().find('[data-product-image-default]').css('opacity', 0);
            });
            $('.studio-image').hide();
        } else if (filterValue === 'studio') {
            $('.studio-image').show().each(function() {
                $(this).parent().find('[data-product-image-default]').css('opacity', 0);
            });
            $('.dog-image').hide();
        }

        // Trigger the swatch click for filtered images
        $('.template-collection .product-information .active-swatch').click();
    }

    // Get the image-filter query parameter from the URL
    var urlParams = new URLSearchParams(window.location.search);
    var imageFilter = urlParams.get('image-filter');

    // If there's an image-filter parameter, apply the corresponding filter
    if (imageFilter) {
        applyImageFilter(imageFilter);
    } else {
        // Default to the 'dogs' filter if no parameter is present (optional)
        applyImageFilter('dogs');
    }

    // Event delegation for the image filter items
    $(document).on('click', '.template-collection .image-filter-item', function() {
        // Remove the active class from all image filters and apply it to the clicked one
        $('.template-collection .image-filter-item').removeClass('active-image-filter');
        $(this).addClass('active-image-filter');
        
        // Get the selected filter
        var imageFilter = $(this).attr('data-filter');

        // Update the URL with the new image-filter query parameter
        var newUrl = new URL(window.location.href);
        newUrl.searchParams.set('image-filter', imageFilter);
        window.history.pushState(null, '', newUrl.toString());

        // Apply the selected image filter
        applyImageFilter(imageFilter);
    });
});



// Event delegation for the quick add on mobile
$(document).on('click', '.quick-add-mobile', function() {
    $('.product-information').removeClass('show-quick-add');
    $(this).parent().next().addClass('show-quick-add');
    $('.product-information').not($(this).parent().next()).each(function(){
       var predefinedSize = $(this).find('.other-options').attr('data-preselected-size');
     var predefinedColor = $(this).find('.other-options').attr('data-preselected-color'); 
      if(predefinedSize){
        $(this).find('.other-options .other-option-value[data-value="'+predefinedSize+'"]').click();
      }
      else{
        if($(this).find('.bydefault-selected').length > 0){
          $(this).find('.bydefault-selected').click()
        }
        else{
         $(this).find('.swatch__link[data-swatch="'+predefinedColor+'"]').click();
          $(this).find('.other-options .other-option-value').eq(0).click();
        }
      }
    })
});
$(document).on('click', '.desktop-filter [data-collapsible-trigger]', function() {
    var elem = $(this);
    setTimeout(function() {
        $('.desktop-filter [data-collapsible-trigger]').each(function() {
            if (elem[0] !== this) {
                $(this).parent().removeAttr('open');
            }
        });
      $('[aria-controls="sort-list"]').attr('aria-expanded','false');
      $('#sort-list').removeClass('popout-list--visible')
    }, 100);
});

  $(document).on('click', '.popout--sort', function() {
    var elem = $(this);
    setTimeout(function() {
        $('.desktop-filter [data-collapsible-trigger]').each(function() {
                $(this).parent().removeAttr('open');
        });
    }, 100);
});

$(document).ready(function () {
    function applyFilters(filterValue) {
        //console.log('Applying filter:', filterValue);
        
        $('.custom-filter-item a').removeClass('active-link');
        var urlParams = new URLSearchParams(window.location.search);
        var isSaleFilter = urlParams.get('filter.p.m.custom.filter_category') === 'Sale';
        //console.log('Sale filter active:', isSaleFilter);

        var $activeLink = filterValue && filterValue !== 'clear-all' ? 
            $('.custom-filter-item a[data-filter="' + filterValue + '"]') : 
            $('.custom-filter-item a[data-filter="clear-all"]');
        $activeLink.addClass('active-link');
        
        if (!$activeLink.length) {
           // console.log('Warning: No matching filter link found for', filterValue);
        }

        var $productsContainer = $('[data-products-grid]');
        var $gridItems = $('[data-grid-item]');
        
        // Hide all products and show loading state
        $gridItems.hide();
        if ($productsContainer.length) {
            $productsContainer.addClass('loading');
        }
        //console.log('Total products hidden:', $gridItems.length);

        var productHandles = $activeLink.attr('data-product');
        
        if (filterValue && filterValue !== 'clear-all' && productHandles) {
            //console.log('Product handles:', productHandles);
            var handlesArray = productHandles.split(',');
            //console.log('Handles array:', handlesArray);
            
            handlesArray.forEach(function (handle) {
                var cleanHandle = handle.trim();
                var $products = $('.' + cleanHandle);
                //console.log('Products found for handle', cleanHandle + ':', $products.length);
                
                $products.each(function() {
                    var $product = $(this);
                    var isOnSale = $product.attr('data-sale') === 'true';
                    
                    if (!isSaleFilter || (isSaleFilter && isOnSale)) {
                        $product.show();
                        //console.log('Showing product:', cleanHandle, 'on sale:', isOnSale);
                    }
                });
            });
        } else {
            // "All" case
            $gridItems.each(function() {
                var $product = $(this);
                var isOnSale = $product.attr('data-sale') === 'true';
                
                if (!isSaleFilter || (isSaleFilter && isOnSale)) {
                    $product.show();
                    //console.log('Showing all product, on sale:', isOnSale);
                }
            });
        }
        
        // Remove loading state
        if ($productsContainer.length) {
            $productsContainer.removeClass('loading');
        }
    }

    function initializeFilters() {
        var urlParams = new URLSearchParams(window.location.search);
        var customFilter = urlParams.get('custom-filter') || 'clear-all';
        var isSaleFilter = urlParams.get('filter.p.m.custom.filter_category') === 'Sale';
        //console.log('Initial custom filter from URL:', customFilter);
        
        // If sale filter is present, add slight delay like original code
        if (isSaleFilter) {
           // setTimeout(function() {
                applyFilters(customFilter);
          //  }, 100);
        } else {
            applyFilters(customFilter);
        }
    }

    // Initialize filters on page load
    initializeFilters();

    // Event listener for filter clicks
    $('.custom-filter-item a').click(function (e) {
        e.preventDefault();
        var filterValue = $(this).attr('data-filter');
        //console.log('Filter clicked:', filterValue);

        var newUrl = new URL(window.location.href);
        newUrl.searchParams.set('custom-filter', filterValue);
        window.history.pushState(null, '', newUrl.toString());

        applyFilters(filterValue);
    });
});



 $('.collection-products, #NoResultLoop, #SearchLoop, #predictiveLoop').on('mouseleave', '.product-item', function() {
  // if ($(window).width() > 767) {
        var $this = $(this);
        var predefinedSize = $this.find('.other-options').attr('data-preselected-size');
        var predefinedColor = $this.find('.other-options').attr('data-preselected-color');

        setTimeout(function() {
            if (predefinedSize) {
              if($this.find('.bydefault-selected').length > 0){
                $this.find('.bydefault-selected').click();
              }
              else{
                $this.find('.other-options .other-option-value[data-value="' + predefinedSize + '"]').click();
              }
            } else {
                $this.find('.swatch__link[data-swatch="' + predefinedColor + '"]').click();
              if($this.find('.bydefault-selected').length > 0){
                $this.find('.bydefault-selected').click();
              }
              else{
                $this.find('.other-options .other-option-value').eq(0).click();
              }
            }
        }, 3000);
  // }
});
 
  const toggleBodyClass = () => {
        if ($('#sort-list').hasClass('popout-list--visible')) {
            $('body').addClass('sort-visible');
          if($('.collection__active__filters').length > 0){
             $('body').addClass('is-filter-active');
          }
        } else {
            $('body').removeClass('sort-visible');
          if($('.collection__active__filters').length > 0){
             $('body').removeClass('is-filter-active');
          }
        }
    };
    toggleBodyClass();
    // Only collection pages have the sort list; observing null threw on every other page.
    const sortList = document.getElementById('sort-list');
    if (sortList) {
        const observer = new MutationObserver(toggleBodyClass);
        observer.observe(sortList, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
  $('.custom-sort-heading .svgSortBy').click(function(){
    $('.popout__toggle[aria-controls="sort-list"]').click()
  })
});

document.addEventListener("DOMContentLoaded", function () {
    // Function to check and apply the 'active-collection-filter' class
    function applyFilterClass() {
        const filtersApplied = window.location.search.includes("filter.");
        if (filtersApplied) {
            document.body.classList.add("active-collection-filter");
        } else {
            document.body.classList.remove("active-collection-filter");
        }
    }

    // Initial check on page load
    applyFilterClass();

    // Reapply class on AJAX updates or filter changes
    document.addEventListener("filtersUpdated", applyFilterClass);
    window.addEventListener("popstate", applyFilterClass); // Handles back/forward navigation
});